<template>
    <v-container fluid class="pa-0 scrollableContent">
        <v-container class="container-custom px-6">
            <Breadcrumbs
                :title="$t('modules.academic.examsbook.breadcrumbs.title')"
                :description="$t('modules.academic.examsbook.breadcrumbs.subtitle')"
            >
                <Button
                    class="px-2"
                    depressed
                    :text="$t('modules.academic.examsbook.action.export')"
                    @clicked="downloadPdf"
                ></Button>
            </Breadcrumbs>
            <v-row>
                <v-col cols="12" class="mb-16">
                    <v-card outlined rounded v-if="students?.length" class="mt-4">
                        <div class="px-6 py-8">
                            <span class="d-flex primary--text text-h6 mx-4">{{ `${$t('modules.academic.examsbook.sheet')} ${invoice}` }}</span>
                            <span class="d-flex mx-4 mb-8">{{ `${$t('modules.academic.examsbook.bookSheet')} ${book}` }}</span>

                            <span class="d-flex justify-left black--text text-h8 mx-4 mt-1">
                                <strong class="mr-2">{{ $t('modules.academic.examsbook.establishment') }}</strong>
                                {{ establishment }}
                            </span>
                            <span class="d-flex justify-left black--text text-h8 mx-4 mt-1">
                                <strong class="mr-2">{{ $t('modules.academic.examsbook.act') }}</strong>
                                {{ act }}
                            </span>
                            <span class="d-flex justify-left black--text text-h8 mx-4 mt-1">
                                <strong class="mr-2">{{ $t('modules.academic.examsbook.subject') }}</strong>
                                {{ subject }}
                            </span>
                            <span class="d-flex justify-left black--text text-h8 mx-4 mt-1">
                                <strong class="mr-2">{{ $t('modules.academic.examsbook.examsYear') }}</strong>
                                {{ year }}
                            </span>
                            <span class="d-flex justify-left black--text text-h8 mx-4 mt-1">
                                <strong class="mr-2">{{ $t('modules.academic.examsbook.examDate') }}</strong>
                                {{ date }}
                            </span>
                        </div>

                        <v-divider></v-divider>

                        <div class="d-flex justify-space-between py-8">
                            <div class="d-flex flex-column justify-center text-center px-8 px-md-12 px-lg-16">
                                <p class="mb-0 subtitle-2">{{ 'Cantidad alumnos' }}</p>
                                <h3 class="primary--text">{{ studentQuantity }}</h3>
                            </div>
                            <div class="d-flex flex-column justify-center text-center px-8 px-md-12 px-lg-16">
                                <p class="mb-0 subtitle-2">{{ 'Cantidad aprobados' }}</p>
                                <h3 class="primary--text">{{ approved }}</h3>
                            </div>
                            <div class="d-flex flex-column justify-center text-center px-8 px-md-12 px-lg-16">
                                <p class="mb-0 subtitle-2">{{ 'Cantidad desaprobados' }}</p>
                                <h3 class="primary--text">{{ disapproved }}</h3>
                            </div>
                            <div class="d-flex flex-column justify-center text-center px-8 px-md-12 px-lg-16">
                                <p class="mb-0 subtitle-2">{{ 'Cantidad ausentes' }}</p>
                                <h3 class="primary--text">{{ absent }}</h3>
                            </div>
                        </div>

                        <v-divider></v-divider>

                        <v-data-table
                            class="superTable__tableExams"
                            item-key="id"
                            :headers="headers"
                            :items="students"
                            hide-default-footer
                            disable-pagination
                        ></v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<style lang="scss" scoped>
    :deep(.superTable__tableExams tbody tr:nth-child(odd)) {
        background-color: #f5f5f5;
    }
</style>

<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import Button from '@/components/Button/Button';
import { $getStudentSheetExamsBook, $reports } from '../Services';
import moment from 'moment';
import download from 'downloadjs'

export default {
    name: 'StudentSheet',
    components: {
        Breadcrumbs,
        Button
    },
    data() {
        return {
            establishment: null,
            act: null,
            subject: null,
            year: null,
            date: null,
            approved: 0,
            disapproved: 0,
            absent: 0,
            studentQuantity: 0,
            students: [],
            headers: [
                { text: this.$t('modules.academic.examsbook.headers.examsNumbers'), value: 'examId', align: 'center', class: 'primary--text text-h6' },
                { text: this.$t('modules.academic.examsbook.headers.identification'), value: 'identification',  align: 'center',class: 'primary--text text-h6' },
                { text: this.$t('modules.academic.examsbook.headers.nameStudent'), value: 'fullName',  align: 'center', class: 'primary--text text-h6' },
                { text: this.$t('modules.academic.examsbook.headers.qualification'), value: 'score',   align: 'center', class: 'primary--text text-h6' },
            ],
        }
    },
    computed: {
        book() {
            return this.$route.params.book ?? ''
        },
        invoice() {
            return this.$route.params.invoice ?? ''
        },
        careerId() {
            return this.$route.params.id ?? ''
        },
        resolution() {
            return this.$route.query.resolution ?? ''
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        async downloadPdf() {
            const { headers, data } = await $reports.academic.find('downloadSingleInvoice2', null, { params: { careerId: this.$route.params.id, book: this.$route.params.book, invoice: this.$route.params.invoice ,resolution: this.$route.query.resolution } })
            download(data, `Alumno ${this.$route.params.book} ${this.$route.params.invoice}.pdf`, headers.get('content-type'))
        },
        async fetchData() {
            try {
                const params = { careerId: this.careerId, book: this.book, invoice: this.invoice, resolution: this.resolution }
                const { data } = await $getStudentSheetExamsBook.find(null, null, { params })

                if (data.length) {
                    this.establishment = data[0].institution
                    this.act = data[0].acta
                    this.subject = data[0].subject
                    this.year = data[0].year
                    this.date = moment(data[0].examDate).format('DD-MM-YYYY')
                }

                this.students = data.map((student, i) => {
                    const score = parseFloat(student.score)
                    if (isNaN(score)) this.absent++
                    else if (score >= 5) this.approved++
                    else this.disapproved++
                    this.studentQuantity++

                    return {
                        id: i,
                        examId: student.numberExams,
                        identification: student.identification,
                        fullName: student.fullName,
                        score: student.score ?? 'AUSENTE',
                    }
                })

                while (this.students.length < 30) {
                    this.students.push({ id: this.students.length, examId: '-', identification: '-', fullName: '-', score: '-' })
                }

            } catch (e) {
                this.students = []
                throw e
            }
        }
    },
}
</script>
